import w200 from "./bannerbg1_mg7pgb_c_scale,w_200.webp";
import w388 from "./bannerbg1_mg7pgb_c_scale,w_388.webp";
import w527 from "./bannerbg1_mg7pgb_c_scale,w_527.webp";
import w652 from "./bannerbg1_mg7pgb_c_scale,w_652.webp";
import w751 from "./bannerbg1_mg7pgb_c_scale,w_751.webp";
import w845 from "./bannerbg1_mg7pgb_c_scale,w_845.webp";
import w926 from "./bannerbg1_mg7pgb_c_scale,w_926.webp";
import w1010 from "./bannerbg1_mg7pgb_c_scale,w_1010.webp";
import w1134 from "./bannerbg1_mg7pgb_c_scale,w_1134.webp";
import w1167 from "./bannerbg1_mg7pgb_c_scale,w_1167.webp";
import w1309 from "./bannerbg1_mg7pgb_c_scale,w_1309.webp";
import w1337 from "./bannerbg1_mg7pgb_c_scale,w_1337.webp";
import w1399 from "./bannerbg1_mg7pgb_c_scale,w_1399.webp";
import w1400 from "./bannerbg1_mg7pgb_c_scale,w_1400.webp";

export default {
  "200w": w200,
  "388w": w388,
  "527w": w527,
  "652w": w652,
  "751w": w751,
  "845w": w845,
  "926w": w926,
  "1010w": w1010,
  "1134w": w1134,
  "1167w": w1167,
  "1309w": w1309,
  "1337w": w1337,
  "1399w": w1399,
  "1400w": w1400,
};
